import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';

export class User extends BaseModel {
    id: number;
    username: string;
    password: string;
    email: string;
    accessToken: string;
    roles: number[];
    pic: string;
    fullname: string;
    nom: string;
    prenom: string;
    sexe: string;
    occupation: string;
	phone: string;
    address: Address;
    lists: any[];
    droits: any[];
    droitsObjets: any[];
    environnement: string;
    signature:string;
    signature_text:string;
    signature_url:string;
    signature_etat:string;
    vidalAPI:boolean=false;
    openID:string;
    type:string;
    clear(): void {
        this.id = undefined;
        this.username = '';
        this.password = '';
        this.email = '';
        this.roles = [];
        this.fullname = '';
        this.accessToken = '';
        this.pic = './assets/media/users/default.jpg';
        this.phone = '';
        this.address = new Address();
        this.address.clear();
        this.lists = [];
        this.environnement = "";
        this.droits = [];
        this.droitsObjets = [];
        this.signature = "";
        this.signature_text = "";
        this.signature_url = "";
        this.signature_etat = "";
        this.vidalAPI = false;
        this.openID='';
        this.nom='';
        this.prenom='';
        this.sexe='';
		this.type='';
    }
}
